import { API_BASE, getImageUrl } from 'config/api';
import { Component } from 'react';
import { Link } from 'react-router-dom';

const defaultImage = (typeof process.env.PUBLIC_URL === 'string' ? process.env.PUBLIC_URL : '') + '/images/logo-blog.png';

class ListBlogComponent extends Component {
    state = {
        blogs: [],
        loading: true
    };

    async componentDidMount() {
        try {
            const res = await fetch(`${API_BASE}/blog?page=1&limit=50`);
            const data = await res.json();
            const list = Array.isArray(data.blogs) ? data.blogs : (Array.isArray(data) ? data : []);
            this.setState({ blogs: list, loading: false });
        } catch (e) {
            this.setState({ blogs: [], loading: false });
        }
    }

    render() {
        const { blogs, loading } = this.state;
        const { limit, showTitle = false } = this.props;
        const posts = limit ? blogs.slice(0, limit) : blogs;

        if (loading) {
            return (
                <section className="modern-resources-section">
                    <div className="container">
                        <p className="modern-resources-status">Loading resources…</p>
                    </div>
                </section>
            );
        }

        return (
            <section className="modern-resources-section">
                {showTitle && (
                    <div className="modern-resources-intro">
                        <div className="container">
                            <div className="modern-intro-panel">
                                <div className="title-section center modern-section-title modern-page-title">
                                    <h2>Insights &amp; Resources</h2>
                                </div>
                                <p>Articles and practical thinking on analytics, MERL, and evidence use.</p>
                            </div>
                        </div>
                    </div>
                )}

                <div className="modern-resources-stage">
                    <div className="container">
                        {!posts.length ? (
                            <div className="modern-resources-empty">
                                <p>No posts yet.</p>
                                <p>Add and publish posts from <strong>Admin → Blog Posts</strong>.</p>
                            </div>
                        ) : (
                            <div className="row modern-resource-grid">
                                {posts.map((data) => {
                                    const imageUrl = getImageUrl(data.image);
                                    const excerpt = data.excerpt
                                        ? (data.excerpt.length > 120 ? data.excerpt.slice(0, 120).trim() + '…' : data.excerpt)
                                        : '';

                                    return (
                                        <div className="col-lg-4 col-md-6 col-sm-12" key={data.id}>
                                            <article className="modern-resource-card">
                                                <Link to={`/blog/${data.slug}`} className="modern-resource-card-media-link" title={data.title}>
                                                    <div className={`modern-resource-media${imageUrl ? '' : ' is-fallback'}`}>
                                                        {imageUrl ? (
                                                            <img
                                                                src={imageUrl}
                                                                alt={data.title}
                                                                onError={(e) => {
                                                                    e.target.src = defaultImage;
                                                                    e.target.parentElement.classList.add('is-fallback');
                                                                }}
                                                            />
                                                        ) : (
                                                            <img src={defaultImage} alt={data.title} />
                                                        )}
                                                    </div>
                                                </Link>

                                                <div className="modern-resource-body">
                                                    <Link to={`/blog/${data.slug}`} className="modern-resource-card-title-link" title={data.title}>
                                                        <h3>{data.title}</h3>
                                                    </Link>
                                                    {excerpt && <p>{excerpt}</p>}
                                                    <div className="modern-resource-meta">
                                                        {data.date && <span>{data.date}</span>}
                                                        <Link to={`/blog/${data.slug}`} className="modern-resource-more">
                                                            Read more <i className="fa fa-long-arrow-right" aria-hidden="true" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </article>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </section>
        );
    }
}

export default ListBlogComponent;
